import React, { useState, useEffect } from "react";
import request from "../../../Helpers/API";
import ProgressBar from "@ramonak/react-progress-bar";
import { DashInforObjetivoVendedor } from "./DashInforObjetivoVendedor";
import { DashScorecardVendedorScreen } from "./DashScorecardVendedorScreen";
import { useHistory } from "react-router-dom";
import { GetMonthNameByNumber } from "../../Finanzas/Helper/GetMonthNameByNumber";
import LinearProgress from "@mui/material/LinearProgress";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const DashScoreCardGerente = () => {
  const [data, setData] = useState([]);
  const [score, setScore] = useState([]);
  const history = useHistory();
  const getMonth = () => {
    const date = new Date();
    return date.getMonth() + 1;
  };

  useEffect(() => {
    request
      .get(`CargaScorecardporVendedorDash/MostrarScorecardVendedor`)
      .then((result) => {
        console.log(result)
        setData(result);
      })
      .catch((error) => {
        Swal.fire("SCCORECARD", JSON.stringify(error), "warning");
      });
  }, []);

  if (data === undefined || data === null || data.length === 0) {
    return <div></div>;
  }


  const formatPorcentaje = (real, objetivo) => {
    if (objetivo === 0 && real === 0) {
      return null;
    }

    if (objetivo === 0) {
      return 100;
    }

    const porcentaje = (real / objetivo) * 100;

    return Math.min(porcentaje, 100);
  };

  const getBarColor = (porcentaje) => {
    if (porcentaje <= 60) {
      return "#f44336";
    } else if (porcentaje > 60 && porcentaje < 80) {
      return "#ffc107";
    } else {
      return "#035917";
    }
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  return (
    <div
      className="dash-tabla-score-card-gerente"
      onClick={() =>
        history.push("/Ventas/DashboardScorecardGerente")
      }
    >
      <div className="header-scordcard-vendedor-gerente">Scorecard General</div>
      <table cellPadding={0} cellSpacing={0}>
        <thead>
          <tr>
            <th>
              <div>Línea</div>
            </th>
            <th>
              <div>Objetivo</div>
            </th>
            <th>
              <div>Real</div>
            </th>
            <th>
              <div>Alcance</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((score) => {
            const porcentaje = formatPorcentaje(
              score.unidades_vendidas,
              score.objetivo
            );
            if (porcentaje === null) {
              return null;
            }
            const barColor = getBarColor(porcentaje);

            return (
              <tr key={score.idlinea}>
                <td>{capitalizeWords(score.linea)}</td>
                <td>{score.idlinea === 14 ? FormatMoney(score.objetivo, 0) : score.objetivo}</td>
                <td>{score.idlinea === 14 ? FormatMoney(score.unidades_vendidas, 0) : score.unidades_vendidas}</td>
                <td>
                  <span className="percentaje">{`${porcentaje.toFixed(
                    0
                  )}%`}</span>
                  <LinearProgress
                    variant="determinate"
                    value={porcentaje}
                    sx={{
                      height: 10,
                      borderRadius: 5,
                      backgroundColor: "#e0e0e0",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: barColor,
                      },
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
